import React from 'react'
import { useTranslation } from 'react-i18next'

import SearchField from '../SearchField'

type TextSearchField = {
	value: string
	onChange(value: string): void
	className?: string
	count?: number
}
export default function TextSearchField({
	className,
	count,
	value,
	onChange,
}: TextSearchField) {
	const { t } = useTranslation()

	return (
		<SearchField
			data-testid='table-search-input'
			value={value}
			className={className}
			count={count}
			compact
			onValueChange={onChange}
			placeholder={t('products_search')}
		/>
	)
}
